var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container page",attrs:{"id":"app"}},[(!['Cue', 'Focus', 'Probe', 'Outcome'].includes(this.$router.currentRoute.name))?_c('div',[_c('h1',[_vm._v("TOPX")])]):_vm._e(),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }